import { Injectable, inject } from '@angular/core';

import { CamGridData } from '../models/grid-data';
import { CamGridFormService } from './grid-form.service';

@Injectable({
  providedIn: 'root',
})
export class CamGridDataService<T extends { id: string }> {
  public grids: { [index: string]: CamGridData<T> } = {};

  private _formService = inject<CamGridFormService<T>>(CamGridFormService);

  public create(key: string) {
    if (!this.has(key)) {
      this.grids[key] = new CamGridData<T>(key, this._formService);
    }
  }

  public get(key: string, create: boolean = false): CamGridData<T> {
    if (!this.has(key) && create) {
      this.create(key);
    }
    return this.grids[key];
  }

  public has(key: string) {
    return !!this.grids[key];
  }
}
